import { cn } from "../lib/cn";
import { CARD_VARIANT_CLASS } from "./card";

/**
 * RailCardSkeleton, matches RailCard's shape (eyebrow, heading, body,
 * footer). Uses `skeleton-sheen` so a low-contrast highlight sweeps
 * across the card rather than the whole card throbbing in sync.
 */
export function RailCardSkeleton({ className }: { className?: string }) {
  return (
    <article
      aria-hidden="true"
      className={cn(
        CARD_VARIANT_CLASS.rail,
        "skeleton-sheen",
        "flex h-full flex-col gap-3",
        className,
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <div className="h-[11px] w-[90px] rounded-full bg-gray-200" />
      </div>
      <div className="h-[26px] w-[70%] rounded-md bg-gray-200" />
      <div className="space-y-1.5">
        <div className="h-[13px] w-[92%] rounded-full bg-gray-200" />
        <div className="h-[13px] w-[78%] rounded-full bg-gray-200" />
      </div>
      <div className="mt-auto">
        <div className="h-[13px] w-[140px] rounded-full bg-gray-200" />
      </div>
    </article>
  );
}
